<template>
    <div class="container">
        <div class="row mt-4">
            <div class="col-lg-6 col-xs-12 float-lg-right">
                <div class="col-12 mb-2 widget">
                    <h4 class="m-2">Instance Details</h4>
                    <table class="table">
                        <tbody>
                            <tr><th>Name</th><td>{{server.Name}}</td></tr>
                            <tr><th>State</th><td><span class="status" v-bind:class="server.State.Name"></span> {{server.State.Name}}</td></tr>
                            <tr><th>IP</th><td>{{server.NetworkInterfaces[0].Association.PublicIp}}</td></tr>
                        </tbody>
                    </table>
                    <div class="col-md-12 mb-2 buttons" v-if="userGroupIs('Developers')">
                        <button class="btn btn-success mr-2"  :disabled="server.State.Name == 'running'" v-on:click="StartInstance()">Start</button>
                        <button class="btn btn-danger mr-2" :disabled="server.State.Name == 'stopped'" v-on:click="RebootInstance()">Reboot</button>
                        <button class="btn btn-danger" :disabled="server.State.Name == 'stopped'" v-on:click="StopInstance()">Stop</button>
                    </div>
                </div>
                <div class="col-12 widget">
                    <img class="cpuImage" v-bind:src="cpuImage" />
                </div>
            </div>
            <div class="col-lg-6 col-xs-12">
                <div class="col-12 widget">
                    <h4 class="m-2">Application Pools</h4>
                    <table class="table mb-2 table-responsive">
                        <tbody>
                            <tr v-for="website in websites" v-bind:key="website.rawName">
                                <td class="align-middle">{{website.name}}</td>
                                <td class="align-middle"><span class="badge badge-secondary" v-bind:class="{
                                        'badge-primary': website.environment == 'live',
                                        'badge-success': website.environment == 'dev',
                                        'badge-info': website.environment == 'staging'
                                    }">{{website.environment}}</span></td>
                                <td><button class="btn" v-on:click="Recycle(website.rawName)">Recycle</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import serverStore from '../app/server-store';
import progressBar from '../app/progressbar';
import auth from '../app/auth';
const _ = require('lodash')

export default {
    name: 'Server',
    data: function() {
        let data = {
            server : {Name: "", State: { Name: "" }},
            cpuImage: "",
            websites: []
        };

        return data;
    },
    methods: {
        LoadInstance() {
            var that = this;
            
            progressBar.start()

            function loadServer() {
                serverStore.getServer(that.$route.params.serverId, that.$route.params.region).then(server => {
                    that.server = server

                    if(that.websites.length == 0)
                    {
                        serverStore.getWebSites(that.server.NetworkInterfaces[0].Association.PublicIp).then((websiteNames) => {
                            

                            let websites = [];
                            for(let websiteName of websiteNames) {
                                let website = {
                                    name: websiteName,
                                    environment: '',
                                    rawName: websiteName
                                }

                                if(websiteName.indexOf('.') > 0) {
                                    website.name = websiteName.substring(websiteName.indexOf('.') + 1)
                                    website.environment = websiteName.substring(0, websiteName.indexOf('.'))
                                }
                                
                                websites.push(website);
                            }

                            websites = _.orderBy(websites, 'name', ['asc']);

                            that.websites = websites;
                        })
                    }
                });
            }

            function loadCpuImage() {
                serverStore.getServerCpuState(that.$route.params.serverId).then(function(image) {
                    that.cpuImage = 'data:image/jpeg;base64,' + btoa(
                        new Uint8Array(image)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                    
                    progressBar.done()
                })
            }

            this.serverPolling = setInterval(loadServer, 2000);
            this.serverImagePolling = setInterval(loadCpuImage, 10000);

            loadServer();
            loadCpuImage();
        },
        StopInstance() {
            serverStore.stopServer(this.server.InstanceId)
        },
        StartInstance() {
            serverStore.startServer(this.server.InstanceId)
        },
        RebootInstance() {
            serverStore.rebootServer(this.server.InstanceId)
        },
        Recycle(siteName) {
            serverStore.recycleAppPool(this.server.NetworkInterfaces[0].Association.PublicIp, siteName);
        },
        userGroupIs(roleName) {
            return auth.getUserGroups().find(c => c == roleName);
        }
    },
    created() {
        this.LoadInstance();
    },
    beforeDestroy() {
        clearInterval(this.polling);
    },
    props: ['serverId']
}
</script>
<style lang="scss">
    .status {
            background: white;
            width: 20px;
            height: 20px;
            display: inline-block;
            border-radius: 10px;
            margin-bottom: -5px;
            -webkit-transition: background-color 1000ms linear;
            -ms-transition: background-color 1000ms linear;
            transition: background-color 1000ms linear;

            &.stopping { 
                background: orange;
            }

            &.stopped {
                background: red; 
            }

            &.pending {
                background: #cbff4e;
            }

            &.running {
                background: #03db00;
            }
        }

    .cpuImage {
        width: 600px;
        max-width: 100%;
    }

    .widget {
        border: 1px solid gray;
        box-shadow: 5px 5px 2px 2px lightgray;
        border-radius: 10px;
    }

    .table-responsive {
        thead {
            display: block;

                tr:nth-child(1) th{
                    background: white;
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }
        }

        tbody {
            height:500px;  
            overflow-y:scroll;
            display: block
        }
    }
</style>